function WhyChoose({ mode }) {
  return (
    <div className="why">

      <h2>
        {mode === "college" ? "Why Choose Us?" : "Why Choose Our Pre-School?"}
      </h2>

      <div className="why-container">

        {mode === "college" ? (
          <>
            <div>
              <h4>Women Empowerment</h4>
              <p>Focused on holistic development of female students.</p>
            </div>

            <div>
              <h4>Quality Infrastructure</h4>
              <p>Modern labs, classrooms and facilities.</p>
            </div>

            <div>
              <h4>Expert Faculty</h4>
              <p>Experienced and highly qualified teachers.</p>
            </div>

            <div>
              <h4>S.N.D.T Affiliation</h4>
              <p>Recognized women's university of India.</p>
            </div>
          </>
        ) : (
          <>
            <div>
              <h4>Safe & Caring Environment</h4>
              <p>We ensure complete safety and comfort for every child.</p>
            </div>

            <div>
              <h4>Play-Based Learning</h4>
              <p>Fun activities that help children learn naturally.</p>
            </div>

            <div>
              <h4>Creative Development</h4>
              <p>Art, music, and storytelling to boost creativity.</p>
            </div>

            <div>
              <h4>Friendly Teachers</h4>
              <p>Trained teachers who care like family.</p>
            </div>
          </>
        )}

      </div>
    </div>
  );
}

export default WhyChoose;